/**
 * Ore fra due orari HH:MM, gestendo il caso "over midnight" (fine < inizio → +24h).
 *
 * Non arrotondare: il BE somma i minuti di tutti i turni e moltiplica una sola
 * volta per la tariffa. Arrotondando per turno l'errore si accumulerebbe e i
 * totali divergerebbero da quelli del BE. L'arrotondamento si fa solo a video.
 */
export const oreFra = (oraStart?: string, oraEnd?: string): number => {
    if (!oraStart || !oraEnd) return 0;
    const parse = (s: string) => {
        const [h, m] = s.split(':').map(Number);
        return (h || 0) * 60 + (m || 0);
    };
    let diff = parse(oraEnd) - parse(oraStart);
    if (diff < 0) diff += 24 * 60;
    return diff / 60;
};
